














import Vue from 'vue'
import TopPanel from './components/TopPanel.vue'
import CookiesInformationBox from './components/CookiesInformationBox.vue'
import LunchInformationBox from './components/LunchInformationBox.vue'
import BannerInformationBox from './components/BannerInformationBox.vue'
import Footer from './components/Footer.vue'

const FETCH_BANNERS_URL = `${location.origin}/watchout/api/banners`

export default Vue.extend({
  components: {
    TopPanel,
    CookiesInformationBox,
    LunchInformationBox,
    BannerInformationBox,
    Footer
  },
  created () {
    if (this.$store.state.isSchedule) {
      return
    }
    const requestURL = new URL(FETCH_BANNERS_URL)
    const requestedBannerId = this.$route && this.$route.query && this.$route.query.banner
    if (requestedBannerId) {
      requestURL.searchParams.set('banner', String(requestedBannerId))
    }
    fetch(requestURL.toString())
      .then(response => response.ok ? response.json() : {})
      .then(banners => this.$store.commit('setBanners', banners || {}))
      .catch(() => {})
  }
})
